import React from "react";
import { Button, Grid } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { BaseTextField } from "components/FormBuilder/fields/BaseTextField";
import { BaseDrawer } from "components/Shared/Base/BaseDrawer";
import LoadingWrapper from "components/Shared/LoadingWrapper";
import InnerShadowBox from "components/Shared/InnerShadowBox";
import { BASE_CONSTANTS } from "constants/baseConstants";

const INITIAL_STATE = {
  bankName: "",
  bankAccountName: "",
  bankAccountNumber: "",
};

const VendorProfileBankDetailsForm = ({
  isBusy = false,
  bankDetails = null,
  onSubmit = () => {},
  onCancel = () => {},
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: INITIAL_STATE,
    mode: "onBlur",
  });

  React.useEffect(() => {
    reset(bankDetails || INITIAL_STATE);
  }, [bankDetails, reset]);

  return (
    <>
      <BaseDrawer.Header>
        {bankDetails ? "Edit Bank Details" : "Add Bank Details"}
      </BaseDrawer.Header>

      <LoadingWrapper loading={isBusy}>
        <InnerShadowBox>
          <BaseDrawer.Content>
            <Grid container spacing={BASE_CONSTANTS.SPACING_LG}>
              <Grid item md={12}>
                <Controller
                  name="bankName"
                  control={control}
                  rules={{ required: "Bank name is required" }}
                  render={({ field }) => (
                    <BaseTextField
                      fullWidth
                      required
                      label="Bank Name"
                      size="small"
                      error={!!errors.bankName}
                      helperText={errors.bankName?.message}
                      {...field}
                    />
                  )}
                />
              </Grid>

              <Grid item md={12}>
                <Controller
                  name="bankAccountName"
                  control={control}
                  rules={{ required: "Account name is required" }}
                  render={({ field }) => (
                    <BaseTextField
                      fullWidth
                      required
                      label="Account Name"
                      size="small"
                      error={!!errors.bankAccountName}
                      helperText={errors.bankAccountName?.message}
                      {...field}
                    />
                  )}
                />
              </Grid>

              <Grid item md={12}>
                <Controller
                  name="bankAccountNumber"
                  control={control}
                  rules={{ required: "Account number is required" }}
                  render={({ field }) => (
                    <BaseTextField
                      fullWidth
                      required
                      label="Account Number"
                      size="small"
                      error={!!errors.bankAccountNumber}
                      helperText={errors.bankAccountNumber?.message}
                      {...field}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </BaseDrawer.Content>
        </InnerShadowBox>

        <BaseDrawer.Actions>
          <Button disabled={isBusy} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            disabled={isBusy}
          >
            {bankDetails ? "Update" : "Save"}
          </Button>
        </BaseDrawer.Actions>
      </LoadingWrapper>
    </>
  );
};

export default VendorProfileBankDetailsForm;